import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgQuestionCircle = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a,.b{fill:none;stroke:currentColor;stroke-width:1.5px;}.a{stroke-linecap:round;stroke-linejoin:round;}.b{stroke-miterlimit:10;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "question-circle" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M9,9a3,3,0,1,1,4,2.829,1.5,1.5,0,0,0-1,1.415V14.25"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M12,17.25a.375.375,0,1,0,.375.375A.375.375,0,0,0,12,17.25h0"
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "b",
			cx: 12,
			cy: 12,
			r: 11.25
		})
	]
});
export default SvgQuestionCircle;
